import clsx from "clsx";
import useGetResourceBalance from "ui/wallet/query/useGetResourceBalance";
import PointsBalance, { PointsBalanceProps } from "../PointsBalance/PointsBalance";

export interface ResourceBalanceProps extends Omit<PointsBalanceProps, "balance" | "isLoading"> {
    className?: string;
    style?: React.CSSProperties;
}

export default function ResourceBalance({ className, ...rest }: ResourceBalanceProps) {
    const { data: resourceBalance = "0", isLoading: isResourceBalanceLoading } = useGetResourceBalance();

    return (
        <PointsBalance
            className={clsx("resource-balance", className)}
            balance={resourceBalance}
            isLoading={isResourceBalanceLoading}
            {...rest}
        />
    );
}
